import { smoothScrollTo } from './utils'

export const intro = () => {
	const listElements = document.querySelectorAll('.intro__nav-element');

    listElements?.forEach(element => element.addEventListener('click', () => {
        const target = document.querySelector(element.dataset.scrollTo);
        target && smoothScrollTo(target)
    }));
}